import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { POST, GET } from "../../../utils/Methods";

export const startQuiz = createAsyncThunk(
  "quiz/startQuiz",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Quiz.startQuiz, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

// export const getQuizQuestions = createAsyncThunk(
//   "quiz/getQuestions",
//   async ({ user_quiz_id, page = 1 }, { rejectWithValue }) => {
//     try {
//       const res = await GET(`quiz/${user_quiz_id}/questions?page=${page}`);
//       return res;
//     } catch (error) {
//       return rejectWithValue(error?.response?.data || error.message);
//     }
//   }
// );

export const getQuizQuestions = createAsyncThunk(
  "quiz/getQuestions",
  async ({ user_quiz_id, page = 1 }, { rejectWithValue }) => {
    try {
      const res = await GET(`/quiz/${user_quiz_id}/questions?page=${page}`);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const updateAnswer = createAsyncThunk(
  "quiz/updateAnswer",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Quiz.updateAnswer, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const submitQuiz = createAsyncThunk(
  "quiz/submitQuiz",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Quiz.submitQuiz, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

// export const getQuizResult = createAsyncThunk(
//   "quiz/getQuizResult",
//   async (user_quiz_id, { rejectWithValue }) => {
//     try {
//       const res = await GET(`${APIS.Quiz.getQuizResult}/${user_quiz_id}`);
//       return res;
//     } catch (error) {
//       return rejectWithValue(error?.response?.data || error.message);
//     }
//   },
// );

export const getQuizResult = createAsyncThunk(
  "quiz/getQuizResult",
  async (user_quiz_id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Quiz.getQuizResult}/${user_quiz_id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

const quizSlice = createSlice({
  name: "quiz",
  initialState: {
    userQuizId: null,
    currentQuestion: null,
    questions: [],
    totalQuestions: 0,
    currentPage: 1,
    quizResult: null,
    status: "idle",
    error: null,
  },
  reducers: {
    resetQuizState: (state) => {
      state.userQuizId = null;
      state.currentQuestion = null;
      state.questions = [];
      state.totalQuestions = 0;
      state.currentPage = 1;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Start Quiz
      .addCase(startQuiz.pending, (state) => {
        state.status = "loading";
      })
      .addCase(startQuiz.fulfilled, (state, action) => {
        state.userQuizId = action.payload?.data?.user_quiz_id;
        state.totalQuestions = action.payload?.data?.total_questions || 0;
        state.status = "succeeded";
      })
      .addCase(startQuiz.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Get Questions
      .addCase(getQuizQuestions.pending, (state) => {
        state.status = "loading";
      })

      .addCase(getQuizQuestions.fulfilled, (state, action) => {
        const responseData = action.payload?.data;

        const questionData = responseData?.data?.[0] || null;

        state.currentQuestion = questionData;
        state.questions = responseData?.data || [];

        state.currentPage = responseData?.current_page || 1;
        state.totalQuestions = responseData?.total || 0;

        state.status = "succeeded";
      })

      .addCase(getQuizQuestions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Update Answer
      .addCase(updateAnswer.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateAnswer.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateAnswer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Submit Quiz
      .addCase(submitQuiz.pending, (state) => {
        state.status = "loading";
      })
      .addCase(submitQuiz.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(submitQuiz.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // get quiz result
      .addCase(getQuizResult.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getQuizResult.fulfilled, (state, action) => {
        state.quizResult = action.payload?.data;
        state.status = "succeeded";
      })
      .addCase(getQuizResult.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetQuizState } = quizSlice.actions;
export default quizSlice.reducer;
